import { Colors, Icon, KeyValueCustomSelect } from "@smartsuite/react-ui";
import { t } from "i18next";
import { useMemo } from "react";
import type { FunctionComponent } from "react";
import { useRootStore } from "../../stores/hooks";
import { Placeholder } from "./Placeholder";
import * as S from "./style";
import { observer } from "mobx-react-lite";

interface ChooseApplicationDropdownProps {
  onOpenCreateAppModal?: () => void;
}

const noop = (): void => {};

export const ChooseApplicationDropdown: FunctionComponent<ChooseApplicationDropdownProps> =
  observer(({ onOpenCreateAppModal = noop }) => {
    const { applications } = useRootStore();

    const options = useMemo(
      () =>
        applications.list.map((app) => ({
          value: app.id,
          label: app.name,
        })),
      [applications.list],
    );

    const createAppHandler = (): void => {
      onOpenCreateAppModal();
    };

    return (
      <>
        <S.Input>
          <Placeholder
            application={{
              label: applications.selectedApplication?.name ?? "",
              value: String(applications.selectedApplication?.id),
            }}
          />
          <KeyValueCustomSelect
            placeholderArrowStyle="filled-dark"
            showClear={false}
            options={options}
            value={
              applications.selectedApplication?.id
                ? String(applications.selectedApplication?.id)
                : undefined
            }
            onChange={(value) => {
              applications.setSelectedApplication(
                applications.list.find(({ id }) => id === value),
              );
            }}
            placeholder=""
            renderOption={({ value, label }) => {
              return (
                <S.ApplicationTile>
                  {value === applications.selectedApplication?.id ? (
                    <S.Text>{label}</S.Text>
                  ) : (
                    <S.GrayedText>{label}</S.GrayedText>
                  )}

                  {value === applications.selectedApplication?.id && (
                    <S.IconWrapper>
                      <Icon color={Colors.bGreen} name="checkmark" />
                    </S.IconWrapper>
                  )}
                </S.ApplicationTile>
              );
            }}
            renderDropdownFooter={() => {
              return (
                <div>
                  <S.HR />
                  <S.Footer onClick={createAppHandler}>
                    <Icon color={Colors.bBlue} name="plus" size="S" />
                    <S.Space />
                    <S.GrayedText>{t("import.create-new-app")}</S.GrayedText>
                  </S.Footer>
                </div>
              );
            }}
          ></KeyValueCustomSelect>
        </S.Input>
      </>
    );
  });
